export default __webpack_public_path__ + "static/media/our_breakfast@3x.f94db63d.png";